import { defineQuery } from 'next-sanity';

export const getCaseStudySettings = defineQuery(`
  *[_type == "caseStudySetting"][0]{
    title,
    metaDescription,
    "featureCaseStudy":[
      featuredCaseStudy1->{
        "id":_id,
        title,
        "smallImglink":"",
        "buttonLink":slug.current,
        "buttonText":"Read Case Study",
        "mainImage":coverImage,
        "description":content[0].children[0].text,
      },
      featuredCaseStudy2->{
      "id":_id,
        title,
        "smallImglink":"",
        "buttonLink":slug.current,
          "buttonText":"Read Case Study",
        "mainImage":coverImage,
        "description":content[0].children[0].text,
      },
      featuredCaseStudy3->{
        "id":_id,
        title,
        "smallImglink":"",
        "buttonLink":slug.current,
        "buttonText":"Read Case Study",
        "mainImage":coverImage,
        "description":content[0].children[0].text,
      },
  ],
  "featuredCaseStudyLogos": [
    {
      "logo": featuredCaseStudyLogo1.logo{
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      "altText": featuredCaseStudyLogo1.altText
    },
    {
      "logo": featuredCaseStudyLogo2.logo {
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      "altText": featuredCaseStudyLogo2.altText
    },
    {
      "logo": featuredCaseStudyLogo3.logo {
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      "altText": featuredCaseStudyLogo3.altText
    }
  ],
  "featuredCaseStudyBackground": [
    {
      "background": featuredCaseStudy1Background.image{
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      "altText": featuredCaseStudy1Background.altText
    },
    {
      "background": featuredCaseStudy2Background.image {
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      "altText": featuredCaseStudy2Background.altText
    },
    {
      "background": featuredCaseStudy3Background.image {
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      "altText": featuredCaseStudy3Background.altText
    }
  ],
  "videoList":{
      "title":videoSectionTitle,
       "featured":{
         "name":featuredVideo.videoTitle,
          "title":featuredVideo.videoSubheading,
           "description":featuredVideo.videoDescription,
           "runtime":featuredVideo.time,
           "videoUrl":featuredVideo.video,
           "thumbnail": featuredVideo.thumbnail{
             ...,
             "imgAsset": asset-> {
               ...
             }
           }
       },
       "videos":[
          {
            "thumbnail": video1.thumbnail{
              ...,
              "imgAsset": asset-> {
                ...
              }
            },
            "title":video1.videoTitle,
            "description":video1.videoDescription,
            "runtime":video1.time,
            "videoUrl":video1.video,
          },
          {
            "thumbnail": video2.thumbnail{
              ...,
              "imgAsset": asset-> {
                ...
              }
            },
            "title":video2.videoTitle,
            "description":video2.videoDescription,
            "runtime":video2.time,
            "videoUrl":video2.video,
          },
          {
            "thumbnail": video3.thumbnail{
              ...,
              "imgAsset": asset-> {
                ...
              }
            },
            "title":video3.videoTitle,
            "description":video3.videoDescription,
            "runtime":video3.time,
            "videoUrl":video3.video,
          },
      ]
    },
    CSS, JS,
    socialProofLogos
   }
    `);

export const getCategorySideCaseStudy = defineQuery(`
    *[_type == "caseStudy" &&($category ==null || category->slug.current == $category) && ($excludeIds == null || !(_id in $excludeIds))] | order(coalesce(editedDate, _updatedAt) desc)[0...3]{
    _id,
    title,
    slug{
      current
    },
    coverImage {
      ...,
      "imgAsset": asset-> {
        ...
      }
    }
  }
    `);

export const getHeropostAndQuotes = defineQuery(`
   *[_type == "caseStudySetting"][0]{
    "categoryHeroPosts":*[_type == "caseStudySetting"][0].categoryHeroPosts[($category ==null || category->slug.current == $category)]{
       category->{
         title
       },
       ...heroPost->{
        _id,
        title,
        slug,
        "coverImage": coverImage  {
          ...,
          "imgAsset": asset-> {
            ...
          }
        }
      }
  },
    "categoryQuotes":*[_type == "caseStudySetting"][0].categoryQuotes[($category ==null || category->slug.current == $category)]{
       category->{
         title
       },
      backgroundQuote->{
         title,
         quote,
          user{
            name,
            location
          }
      },
      "quotes":[
         quote1->{
            title,
         quote,
          user{
            name,
            location
          }
         },
         quote2->{
            title,
         quote,
          user{
            name,
            location
          }
         }
      ]
  },
}
  `);
export const getCaseStudybySlug = defineQuery(`
    *[_type == "caseStudy" && slug.current == $slug][0]{
    ...,
     coverImage,
     logoImage,
     template,
    metaDescription,
    CSS, JS,
    author->{
    name,
    profileImage
    }, 
    category->{title, slug, _id},
    testimonial->{
      name,
      content,
      country
    },
    "randomTestimonialCount": select(
      testimonial == null => count(*[_type == "testimonial" && includeInRandom == true]),
      null
    ),
    "customContent" : null,
    "content": select(template == "blurbLayout" => customContent,  content[]{
      ...,
      markDefs[]{...,
        _type == "internalLink" => { 
        "slug": @.reference->slug.current,
         "type":@.reference->_type     
         }
      },
      _type == "image" => {
        ...,
        asset-> {
          ...,
        }
      }
    }),
    "text": pt::text(content),
    "relatedCaseStudies": *[_type == "caseStudy" && _id != ^._id && defined(keyword) && keyword._ref == ^.keyword._ref][0...2] {
     _id,
      title,
      coverImage {
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      slug,
    } 
    }
  `);
export const getRecentCaseStudyPost = defineQuery(`
 *[_type ==$caseStudyType && ($excludeIds == null || !(_id in $excludeIds)) && category._ref == $category ][0...3]{
      _id,
    title,
    coverImage {
      ...,
      "imgAsset": asset-> {
        ...
      }
    },
    slug,
   }
  `);
export const getCaseStudiesSeoData = defineQuery(`
   *[_type == "caseStudySetting"]{
   title,
    metaDescription,
   }
  `);

export const getCaseStudiesDetailSeoData = defineQuery(`
   *[_type == "caseStudy" && slug.current == $slug][0]{
   title,
   slug,
   metaDescription,
   content,
   coverImage,
   }
  `);

export const getAllCaseStudiesSlugs = defineQuery(`
  *[_type == "caseStudy" && defined(slug.current)][].slug.current`);
